import styled from 'styled-components'

import { PageTitleUnstyled } from 'Components/PageTitle/unstyled'

export const PageTitle = styled(PageTitleUnstyled)`
  color: ${props => props.theme.colors.ebonyClay + 'd9'};
  font-size: ${props => props.theme.fontSizes.pageTitle};
  margin: 20px 0 30px 0;

  .status {
    color: ${props => props.theme.colors.primary};
    display: inline-block;
    margin-left: 5px;
    &:first-letter {
      text-transform: uppercase;
    }
  }

  > svg {
    width: 24px;
    height: 24px;
    fill: ${props => props.theme.colors.regentGray};
  }

  > svg:not(.icon-right):not(.icon-add) {
    float: left;
    margin: 5px 15px 0 0;
    transform: rotate(90deg);
  }

  svg.icon-right {
    margin-left: 16px;
  }
  .link-edit-main {
    position: absolute;
    right: 40px;
    top: 25px;
    svg {
      float: unset !important;
      margin: unset !important;
      transform: unset !important;
    }
  }
`
